(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/white-card-header.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/white-card-header.js');
'use strict';

const _excluded = ["children", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  CardHeader
} = svs.ui.ReactCard;

const WhiteCardHeader = _ref => {
  let {
      children,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    React.createElement(CardHeader, _extends({
      className: "card-white-header ".concat(className)
    }, props), React.createElement("h3", {
      className: "h4 margin-0"
    }, children))
  );
};
svs.myProfile.react.pages.myInformation.myInformation.components.WhiteCardHeader = WhiteCardHeader;

 })(window);